export default __webpack_public_path__ + "static/media/water_selected.1615ad1f.svg";